import Heading from "../components/heading";
import {useHistory, useParams } from "react-router-dom";
import {templates} from "../utils/constants";
import List from "../components/list";
import {useContext, useEffect, useState} from "react";
import Page from "../models/page";
import ListItem from "../components/list-item";
import FirebaseContext from "../utils/firebase-context";
import SpaceBetween from "../components/space-between";
import Section from "../components/section";
import PrimaryButton from "../components/primary-button";

export default function PageOverviewScreen() {
    const {handle} = useParams<{ handle: string }>();
    const firebase = useContext(FirebaseContext);
    const history = useHistory();

    const [pages, setPages] = useState<Page[]>([]);

    useEffect(() => {
        return firebase.getPages().where("handle", "==", handle).onSnapshot(snapshot => {
            const ps: Page[] = [];
            snapshot.forEach(doc => ps.push(doc.data() as Page));
            setPages(ps);
        });
    }, [firebase, handle]);

    return <>
        <Section>
            <SpaceBetween>
                <Heading>
                    {templates.find(t => t.handle === handle)?.title}
                </Heading>
                <PrimaryButton onClick={() => history.push(`/pages/${handle}/new`)}>
                    Neue Seite
                </PrimaryButton>
            </SpaceBetween>
        </Section>
        <div>
            {pages.length > 0 && <List>
                {pages.map(page => <ListItem key={page.id}>
                    {page.title}
                </ListItem>)}
            </List>}
        </div>
    </>
}